/**
 * Domain model for PLP widget banners shown between product rows.
 */
export class BannerWidget {
  name: string;
  imageUrl: string;
  desktopImageUrl: string | null;
  landingUrl: string | null;
  bannerType: string;

  constructor(props: {
    name: string;
    imageUrl: string;
    desktopImageUrl: string | null;
    landingUrl: string | null;
    bannerType: string;
  }) {
    this.name = props.name;
    this.imageUrl = props.imageUrl;
    this.desktopImageUrl = props.desktopImageUrl;
    this.landingUrl = props.landingUrl;
    this.bannerType = props.bannerType;
  }
}

